module.exports = __webpack_public_path__ + "media/highly_damped_large_room.50e87d0d.wav";